<template>
  <div class="setUp">
    <!-- 导航栏 -->
    <van-nav-bar :border="true" ref="navBar" @click-left="onBack">
      <template #title>
        <span class="title">设置</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" size=".7rem" color="#FF971C" />
      </template>
    </van-nav-bar>
    <!-- 内容 -->
    <div class="setUp-wrapper">
      <ul>
        <li @click="show=true">修改昵称</li>
        <li>
          <span>消息推送</span>
          <van-switch
            :value="checked"
            size="20px"
            active-color="#FF971C"
            inactive-color="#ddd"
            @input="onInput"
          />
        </li>
        <li @click="switchAccount">
          <span>切换账号</span>
        </li>
        <li @click="logout">退出登录</li>
      </ul>
    </div>
    <!-- 修改昵称组件 -->
    <van-dialog
      v-model="show"
      title="修改昵称"
      :before-close="beforeClose"
      show-cancel-button
      @confirm="onConfirm()"
    >
      <div class="newNickname">
        <input type="text" placeholder="请输入新昵称" v-model="newNickName" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { contTools, lyTool } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "setUp",
  mixins: [contTools, lyTool],
  components: {},
  data() {
    return {
      show: false,
      newNickName: "",
      checked: this.$cookies.get("is_news_push") == 1 ? true : false,
    };
  },
  watch: {
    checked: {
      handler: function (newVal, oldVal) {
        console.log("newVal,oldVal", newVal, oldVal);
      },
      // 深度观察监听
      deep: true,
    },
  },
  computed: {},
  created() {},
  methods: {
    // 返回上一级
    onBack() {
      this.$router.go(-1);
    },
    // 消息推送
    onInput() {
      this.$dialog
        .confirm({
          title: "提醒",
          message: "是否切换开关？",
        })
        .then(() => {
          let data = comTools.assignObj(this.wapConfig(), {
            mobile: this.$cookies.get("mobile"),
            user_token: this.$cookies.get("userToken"),
            new_id: this.urlObj.newid,
          });
          data.sign = comTools.querySort(data);
          wapApiFun.newsPush(data).then((res) => {
            if (res.code == 200) {
              this.$cookies.set("is_news_push", res.data.is_news_push);
              this.checked = res.data.is_news_push == 1 ? true : false;
              console.log(this.checked, 'cheched');
            } else {
              this.$toast(res.msg);
            }
          });
        });
    },
    // 修改昵称
    onConfirm() {
      if (this.newNickName) {
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.$cookies.get("mobile"),
          user_token: this.$cookies.get("userToken"),
          nick_name: this.newNickName,
        });
        data.sign = comTools.querySort(data);
        wapApiFun.modifyNick(data).then((res) => {
          if (res.code == 200) {
            console.log("修改昵称", res);
            this.$toast(res.msg);
            this.show = false;
          } else {
            this.beforeClose();
            this.$toast(res.msg);
          }
        });
      } else {
        this.$toast("请填写新昵称");
      }
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        done(false);
      } else {
        done();
      }
    },
    // 切换账号
    switchAccount() {
      this.$router.push({
        path: "/login",
      });
    },
    // 退出登录
    logout() {
      this.$dialog
        .confirm({
          title: "退出登录",
        })
        .then(() => {
          console.log("确定");
          this.$cookies.remove("userToken");
          this.$cookies.remove("mobile");
          this.$cookies.set("routePath");
          this.$router.push({
            path: "/",
          });
        })
        .catch(() => {
          console.log("取消");
        });
    },
  },
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.setUp {
  width: 100%;
  min-height: 100vh;
  //  background-color: #ddd;
  .view-bg-color();
  // 导航栏
  .van-nav-bar {
    color: #fff;
    .title,
    .right {
      font-weight: bold;
      // color: #fff;
    }
  }
  .setUp-wrapper {
    ul {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 1rem;
      li {
        .jc-between();
        padding: 0.3rem 0;
      }
    }
  }

  // 修改昵称组件
  .van-dialog {
    .newNickname {
      padding-top: 0.5rem;
      padding-bottom: 0.8rem;
      text-align: center;
      input {
        text-align: center;
      }
    }
  }
}
</style>